import React from 'react';
export function Footer() {
  return <footer className="bg-dark text-gray-400 py-16 px-4 text-center" data-id="element-79">
      <div className="max-w-4xl mx-auto" data-id="element-80">
        <div className="text-3xl mb-6 opacity-80" data-id="element-81">🎈</div>
        <p className="mb-12 text-gray-300 font-medium text-lg leading-relaxed max-w-2xl mx-auto" data-id="element-82">
          Tu peque se merece una fiesta mágica. Y vos te merecés organizarla sin
          estrés.
        </p>

        <div className="border-t border-gray-800 pt-10 flex flex-col md:flex-row justify-between items-center gap-6 text-sm" data-id="element-83">
          <p data-id="element-84">© Mega Pack Fiesta Lista — Todos los derechos reservados</p>
          <div className="flex gap-6" data-id="element-85">
            <a href="#" className="font-medium hover:text-white transition-colors" data-id="element-86">
              Contacto
            </a>
            <a href="#" className="font-medium hover:text-white transition-colors" data-id="element-87">
              Soporte
            </a>
            <a href="#" className="font-medium hover:text-white transition-colors" data-id="element-88">
              Política de Privacidad
            </a>
          </div>
        </div>
      </div>
    </footer>;
}